import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { DetailsSidebar } from '@/modules/transaction/components/DetailsSidebar';
import { TermsSignature } from '@/modules/common/components/TermsSignature';

import {
  IInvestmentReview,
  IDetails
} from '@/modules/transaction/services/fund-pension-investment';
import {
  termSignature,
  ITermSignature
} from '@/modules/transaction/services/product-investment';

import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStep',
  setup(__props) {

const investmentReview = inject('investmentReview') as Ref<IInvestmentReview>;
const termSignatureData = inject('termSignatureData') as Ref<ITermSignature>;

const makeInvestment = inject('fetchInvestment', async () => ({}));

const isLoading = ref(false);
const isTermSignatureOpen = ref(false);
const isDetailsOpen = ref(false);
const sidebarDetails = ref<IDetails>({
  title: '',
  description: '',
  button: null
});

function openDetails(details: IDetails | null) {
  if (!details) return;

  sidebarDetails.value = details;
  isDetailsOpen.value = true;
}

async function handleClick() {
  if (termSignatureData.value.requestTermsSignature.length > 0) {
    isTermSignatureOpen.value = true;
    return;
  }

  await fetchInvestment();
}

async function acceptTerms() {
  isTermSignatureOpen.value = false;

  await fetchAcceptTerms();
  await fetchInvestment();
}

async function fetchInvestment() {
  try {
    isLoading.value = true;

    await makeInvestment();
  } finally {
    isLoading.value = false;
  }
}

async function fetchAcceptTerms() {
  try {
    isLoading.value = true;

    await termSignature(
      termSignatureData.value.requestTermsSignature[0].productId
    );
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,investmentReview, termSignatureData, makeInvestment, isLoading, isTermSignatureOpen, isDetailsOpen, sidebarDetails, openDetails, handleClick, acceptTerms, fetchInvestment, fetchAcceptTerms, HeadingDisplay, ContentDisplay, Heading, ListDisplay, ButtonContainer, ButtonPrimary, DetailsSidebar, TermsSignature }
}

})